import { APP_NAMES } from '~/core/constants'
import appConfig from '../app-config'
import { getPriceString } from '../core/utils'

const usageTypeMap = {
  metered: 'per_user'
}

const billingIntervalMap = {
  month: 'billed_monthly',
  day: 'billed_daily'
}

const normalizeFeatures = features =>
  features.map(feature => feature.toUpperCase().replace(/-/g, '_'))

const normalizePlan = plan => {
  const {
    advertisedFeatures,
    amount,
    currency,
    expectedUnits,
    id,
    interval,
    overageLinks,
    usageType,
    planType,
    tiers
  } = plan

  const overage = overageLinks[0]

  return {
    advertisedFeatures: normalizeFeatures(advertisedFeatures),
    amount: amount / 100,
    billingRecurrence: billingIntervalMap[interval],
    currency,
    expectedUnits,
    id,
    interval,
    overage: overage && getPriceString(currency, overage.amount / 100),
    price: getPriceString(currency, amount / 100),
    recurrence: usageTypeMap[usageType],
    planType,
    tiers
  }
}

const normalizeMeetProducts = products =>
  products
    .filter(p => p.pricingPlans.length > 0)
    .map(p => {
      const product = { name: p.name, id: p.id }
      const activePlan = p.pricingPlans.find(plan => plan.active)
      product.plan = activePlan ? normalizePlan(activePlan) : null

      return product
    })

const normalizeMeetPlan = p => normalizePlan(p[0].plan)

const normalizeForAnalytics = plans => plans[0].pricingPlans.map(p => p.amount)

const getOverageCost = (entries, type) => {
  const entry = entries.find(({ overageType }) => overageType === type)

  return entry ? entry.amount / 100 : null
}

const normalizeVpaasProducts = products =>
  products[0]
    .pricingPlans.filter(p => p.active)
    .map(({ id, name, currency, amount, overageLinks, expectedUnits }) => {
      const totalCost = amount / 100

      return {
        id,
        name,
        currency,
        users: expectedUnits,
        totalCost,
        userCost: (totalCost / expectedUnits).toFixed(2),
        overages: {
          dialOut: getOverageCost(overageLinks, 'CALLOUT_ADDON'),
          mau: getOverageCost(overageLinks, 'MAU_OVERAGE'),
          recording: getOverageCost(overageLinks, 'RECORDING_ADDON'),
          sipInbound: getOverageCost(overageLinks, 'SIP_CALL_IN_ADDON'),
          sipOutbound: getOverageCost(overageLinks, 'SIP_CALL_OUT_ADDON'),
          streaming: getOverageCost(overageLinks, 'STREAMING_ADDON'),
          transcription: getOverageCost(overageLinks, 'TRANSCRIPTION_ADDON')
        }
      }
    })
    .sort((p1, p2) => p1.users - p2.users)
    .map((props, index, plans) => ({
      ...props,
      shouldContactSales: index === plans.length - 1
    }))

const MAPPINGS = {
  [APP_NAMES.VPAAS]: {
    normalizePlan: p => p,
    normalizeProducts: normalizeVpaasProducts,
    normalizeForAnalytics
  },
  [APP_NAMES.MEET]: {
    normalizePlan: normalizeMeetPlan,
    normalizeProducts: normalizeMeetProducts,
    normalizeForAnalytics
  }
}

export default {
  get current () {
    return MAPPINGS[appConfig.current.name]
  }
}
